<Boundary>
  {#if readyToRender}
  <div id={getComponentWrapperElementId(editorOptions?.componentId)} bind:this={wrapperEl} on:message={handleMessage} on:sequentialdisplay={handleSequentialDisplay} class="cards-component-wrapper" class:sticky-enabled={sticky} class:sticky-active={stickyActive && !emmEnabled} class:wait-content-loaded={waitUntilContentLoaded} class:content-loaded={contentQuiescent} data-component-type={editorOptions?.componentTypeName} data-component-id={editorOptions?.componentId} data-sequence-id={editorOptions?.sequenceId} style={internalStyle} on:mouseenter={handleMouseEnter} on:mouseleave={handleMouseLeave} {...parentAttributes}>
    {#if showEditorControls}
      <div class="cards-editor-component-overlay-controls" class:this-selected={thisSelected} class:clone-source-selected={cloneSourceSelected} class:clone={subtreeIsCloned} class:clone-with-selection={subtreeIsCloned && editorOptions.allowEditsToSelfIfCloned}>
        <CardsEditorComponentControls active={thisSelected} {buttons} />
      </div>
    {/if}
    <slot></slot>
  </div>
  {#if sticky && !emmEnabled}
  <div class="cards-component-wrapper-sticky-placeholder" bind:this={stickyPlaceholderEl}></div>
  {/if}
  {/if}
</Boundary>

<style>
  *, *::before, *::after {
    box-sizing: border-box;
  }

  .cards-component-wrapper {
    transition: opacity 0.5s ease;
  }

  .cards-component-wrapper.sticky-active {
    position: absolute !important;
    /*top: 0 !important;*/
    height: auto !important;
    width: 100% !important;
    z-index: 6000 !important;
  }

  .cards-component-wrapper.wait-content-loaded:not(.content-loaded) {
    background-color: transparent;
    opacity: 0;
  }

  .cards-component-wrapper-sticky-placeholder {
    height: 0;
  }

  .cards-editor-component-overlay-controls {
    position: absolute;
    top: 0px;
    left: 0px;
    /*height: 21px;*/
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    max-width: 100%;
    z-index: 1000;
    padding: 0px 5px;
    font-size: 13px;
    font-family: 'SF UI Display';
  }

  .cards-editor-component-overlay-controls:not(.clone), .cards-editor-component-overlay-controls.clone.clone-with-selection {
    background-color: var(--cards-editor-component-unselected-background-color);
    color: var(--cards-editor-component-unselected-text-color);
  }

  .cards-editor-component-overlay-controls.clone {
    border-right: 2px dotted var(--cards-editor-component-unselected-background-color);
    border-bottom: 2px dotted var(--cards-editor-component-unselected-background-color);
    color: var(--cards-editor-component-unselected-background-color);
  }

  .cards-editor-component-overlay-controls.clone.clone-source-selected {
    border-right: 2px dotted var(--cards-editor-component-selected-background-color);
    border-bottom: 2px dotted var(--cards-editor-component-selected-background-color);
  }

  .cards-editor-component-overlay-controls.this-selected {
    background-color: var(--cards-editor-component-selected-background-color);
    color: var(--cards-editor-component-selected-text-color);
    font-weight: bold;
  }</style>

<script context="module" lang="ts">var _a, _b, _c;
import { derived, writable, get } from "svelte/store";
import { f7 } from "framework7-svelte";
/*
const stickyElementHeights = [];

window.addEventListener('load', () => {
  f7ready(() => {
    f7.view.main.router.on('routeChange', (newRoute, prevRoute) => {
      stickyElementHeights.length = 0;
    });
  });
});
*/
const LOCAL_COPY_PASTE_KEY = 'janus-local-copy-paste-item';
const restoredCopyPasteItem = JSON.parse(window.localStorage.getItem(LOCAL_COPY_PASTE_KEY) || '{}');
const currentCopyPasteItem = writable(restoredCopyPasteItem);
currentCopyPasteItem.subscribe((value) => {
    window.localStorage.setItem(LOCAL_COPY_PASTE_KEY, JSON.stringify(value));
});
window.addEventListener('storage', (event) => {
    if (event.storageArea === window.localStorage && (!event.key || event.key === LOCAL_COPY_PASTE_KEY)) {
        currentCopyPasteItem.set(JSON.parse(window.localStorage.getItem(LOCAL_COPY_PASTE_KEY) || '{}'));
    }
});
</script>

<script lang="ts">var _a, _b, _c;
import { Boundary } from '@crownframework/svelte-error-boundary/src/index';
import { CardsPageContextKey, CardsTabContextKey } from './context';
import { getContext, setContext, onDestroy, onMount, afterUpdate, tick } from "svelte";
import './CardsEditorInterfaces';
import CardsEditorComponentControls from './CardsEditorComponentControls.svelte';
import './CardsEditorComponentInterfaces';
import _ from 'lodash';
import 'svelte-dnd-action';
import { v4 as uuid4 } from "uuid";
import { CardsEditorSubtreeContextKey } from "./context";
import { pbt } from '../../../js/i18n';
import { getComponentWrapperElementId, getEditorDisplayName, sendMessageToComponent } from "../utilities";
import "json-schema";
import "./actions";
import { afterUpdateDebounce, getScrollTargetPosition, getVerticalScrollParent } from "js/utilities";
export let style = "";
export let parentAttributes = {};
export let editorOptions;
export let wrapperEl = null;
export let messageHandler = () => { };
export let sticky = false;
export let readyToRender = true;
export let waitUntilContentLoaded = false;
export let contentLoaded = false;
export let disableWaitUntilContentLoaded = false;
export let imageLoadBarrierStore = null;
const pageContext = getContext(CardsPageContextKey);
const tabContext = getContext(CardsTabContextKey);
const emm = pageContext.editorModeManager;
const emmEnabledStore = emm.getEnabledStore();
const emmPreviewStore = emm.getPreviewStore();
const emmSelectedStore = emm.getSelectedComponentStore();
const editorOptionsStore = writable(editorOptions);
const thisPreviewStore = writable(false);
const parentSubtreeContextStore = getContext(CardsEditorSubtreeContextKey) || writable(null);
const thisSubtreeContextStore = derived([parentSubtreeContextStore, editorOptionsStore, thisPreviewStore], ([parentSubtreeContext, thisEditorOptions, thisPreview], set) => {
    var _a, _b;
    const thisCloned = (_.isNil(thisEditorOptions.cloned)) ? !!((_b = (_a = thisEditorOptions.component) === null || _a === void 0 ? void 0 : _a.__expandRepeats) === null || _b === void 0 ? void 0 : _b.cloned) : thisEditorOptions.cloned;
    set({
        componentId: thisEditorOptions.componentId,
        component: thisEditorOptions.component,
        subtreeCloned: (parentSubtreeContext === null || parentSubtreeContext === void 0 ? void 0 : parentSubtreeContext.subtreeCloned) || thisCloned,
        subtreePreview: (parentSubtreeContext === null || parentSubtreeContext === void 0 ? void 0 : parentSubtreeContext.subtreePreview) || thisPreview,
        /* --- */
        getChildSubtree,
        moveUpChild,
        moveDownChild,
        cloneChild,
        removeChild,
        addChildBefore,
        addChildAfter
    });
});
const pageContentLoadedStore = pageContext.pageContentLoadedStore;
setContext(CardsEditorSubtreeContextKey, thisSubtreeContextStore);
let internalStyle = style;
let emmEnabled;
let emmPreview;
let emmSelected;
let parentSelected = false;
let thisSelected = false;
let showEditorControls = false;
let buttons = [];
let editPopupOpened = false;
let editorSchema = {};
let thisMouseHover = false;
let stickyPlaceholderEl;
let lockedHeightPx = 0;
$: emmEnabled = $emmEnabledStore;
$: emmPreview = $emmPreviewStore;
$: emmSelected = $emmSelectedStore;
$: parentSelected = (emmSelected === null || emmSelected === void 0 ? void 0 : emmSelected.sequenceId) === editorOptions.parentSequenceId; // TODO: should this be based on component ID?
$: thisSelected = (emmSelected === null || emmSelected === void 0 ? void 0 : emmSelected.id) === editorOptions.componentId;
$: thisCloned = (_.isNil(editorOptions.cloned)) ? !!((_b = (_a = editorOptions.component) === null || _a === void 0 ? void 0 : _a.__expandRepeats) === null || _b === void 0 ? void 0 : _b.cloned) : editorOptions.cloned;
$: cloneSourceSelected = thisCloned && (emmSelected === null || emmSelected === void 0 ? void 0 : emmSelected.id) === editorOptions.sourceElementId;
$: outlineMode = emmEnabled && (!emmPreview || (emmPreview && editorOptions.allowPreviewHoverEdit && (thisMouseHover || thisSelected)));
$: showEditorControls = outlineMode && (!emmPreview || (emmPreview && editorOptions.allowPreviewHoverEdit && thisMouseHover));
$: hasChldren = getOrCreateChildrenArray(editorOptions).length > 0;
$: $editorOptionsStore = editorOptions;
//$: $thisIsClonedStore = (_.isNil(editorOptions.cloned))? !!editorOptions.component?.__expandRepeats?.cloned : editorOptions.cloned;
$: subtreeIsCloned = $thisSubtreeContextStore.subtreeCloned;
$: pageContentLoaded = $pageContentLoadedStore;
$: {
    let css = style;
    if (outlineMode) {
        css += `--cards-editor-component-primary-color: ${editorOptions.primaryColor};`;
        css += `--cards-editor-component-reverse-text-color: ${editorOptions.reverseTextColor};`;
        css += `--cards-editor-component-unselected-background-color: ${editorOptions.unselectedBackgroundColor};`;
        css += `--cards-editor-component-unselected-text-color: ${editorOptions.unselectedTextColor};`;
        css += `--cards-editor-component-selected-background-color: ${editorOptions.selectedBackgroundColor};`;
        css += `--cards-editor-component-selected-text-color: ${editorOptions.selectedTextColor};`;
        let borderOrOutline = (emmPreview) ? 'outline' : 'border';
        if (cloneSourceSelected) {
            css += `${borderOrOutline}: 2px dotted var(--cards-editor-component-selected-background-color);`;
        }
        else if (subtreeIsCloned && !(editorOptions.allowEditsToSelfIfCloned && thisSelected)) {
            css += `${borderOrOutline}: 2px dotted var(--cards-editor-component-unselected-background-color);`;
        }
        else if (parentSelected) {
            css += `${borderOrOutline}: 2px dashed lightpink;`;
        }
        else if (thisSelected) {
            css += `${borderOrOutline}: 2px solid var(--cards-editor-component-selected-background-color);`;
        }
        else {
            css += `${borderOrOutline}: 2px solid var(--cards-editor-component-unselected-background-color);`;
        }
        if (!emmPreview) {
            css += 'padding: 5px;';
            css += 'margin: initial;';
            if (thisSelected) {
                css += 'background: white;';
            }
            else {
                css += 'background: initial;';
            }
        }
        else /* in preview mode */ {
            css += 'min-height: 25px;'; // to allow room for the user to hover over and get editor controls
            css += 'position: relative; z-index: 9999;'; // make sure selected item is at the top
        }
    }
    else {
        // if not in outline mode, apply the styles coming from the parent
        // css += style;
    }
    if (showEditorControls) {
        css += 'position: relative;';
        if (!emmPreview) {
            css += 'padding-top: 28px;';
        }
    }
    /*
    if (editorOptions.forceWidth) {
      css += `width: ${editorOptions.forceWidth}; margin: auto; overflow: scroll;`;
    }
    */
    if (stickyActive) {
        css += `top: ${stickyTop}px !important;`;
    }
    if (lockedHeightPx > 0) {
        css += `min-height: ${lockedHeightPx}px !important;`;
        if (fadeDuringSourceChange) {
            css += `opacity: 0 !important; visibility: hidden !important;`;
        }
    }
    internalStyle = css;
}
$: if (subtreeIsCloned) {
    const displayName = getEditorDisplayName(editorOptions);
    buttons = [
        Object.assign({ id: 'NAME', label: displayName }, (editorOptions.allowEditsToSelfIfCloned && { onClick: onNameClick })),
    ];
}
else {
    const displayName = getEditorDisplayName(editorOptions);
    buttons = [
        { id: 'NAME', label: displayName, onClick: onNameClick },
    ];
    /*
    if (editorSchema) {
      buttons.push({ id: 'EDIT', icon: 'square_pencil_fill', tooltip: $pbt('Edit this component.'), showOnlyWhenActive: true, onClick: onEdit });
    }
    */
    for (const button of ((editorOptions === null || editorOptions === void 0 ? void 0 : editorOptions.extraButtons) || [])) {
        buttons.push(button);
    }
    if ($parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.componentId) {
        buttons.push({ id: 'SELECT_PARENT', icon: 'arrow_up_left_square_fill', tooltip: $pbt('Select parent component.'), showOnlyWhenActive: true, onClick: onSelectParent });
    }
    /*
    if (editorOptions.allowMovement) {
      buttons.push({ id: 'MOVE_PREV', icon: 'arrowtriangle_up_fill', tooltip: $pbt('Move component up in order.'), showOnlyWhenActive: true, onClick: onMoveUp });
      buttons.push({ id: 'MOVE_NEXT', icon: 'arrowtriangle_down_fill', tooltip: $pbt('Move component down in order.'), showOnlyWhenActive: true, onClick: onMoveDown });
    }
    if (editorOptions.allowRepeats) {
      buttons.push({ id: 'ADD_REPEAT', icon: 'rectangle_stack_fill_badge_plus', tooltip: $pbt('Increase the number of times this component is repeated in order. Repeated components share the same configuration as the original component.'), showOnlyWhenActive: true, onClick: onAddRepeat });
      buttons.push({ id: 'REMOVE_REPEAT', icon: 'rectangle_stack_fill_badge_minus', tooltip: $pbt('Decrease the number of times this component is repeated in order. Repeated components share the same configuration as the original component.'), showOnlyWhenActive: true, onClick: onRemoveRepeat });
    }
    */
    if (editorOptions.allowDuplication) {
        buttons.push({ id: 'ADD_SIBLING_BEFORE', icon: 'arrow_up_doc_fill', tooltip: $pbt('Add a new component before this one.'), showOnlyWhenActive: true, onClick: onAddSiblingBefore });
        buttons.push({ id: 'ADD_SIBLING_AFTER', icon: 'arrow_down_doc_fill', tooltip: $pbt('Add a new component after this one.'), showOnlyWhenActive: true, onClick: onAddSiblingAfter });
        buttons.push({ id: 'CLONE', icon: 'doc_on_doc_fill', tooltip: $pbt('Create an independent copy of this component. Copied components do not share any configuration with the original component.'), showOnlyWhenActive: true, onClick: onClone });
    }
    if (editorOptions.allowChildren) {
        buttons.push({ id: 'ADD_CHILD', icon: 'plus_square_fill_on_square_fill', tooltip: $pbt('Add a new child to this component.'), showOnlyWhenActive: true, onClick: onAddChild });
    }
    if (editorOptions.allowDeletion && editorOptions.allowCopyPaste) {
        buttons.push({ id: 'CUT', icon: 'scissors', tooltip: $pbt('Cut this component. This deletes the component after copying it to the clipboard.'), showOnlyWhenActive: true, onClick: onCut });
    }
    if (editorOptions.allowCopyPaste) {
        buttons.push({ id: 'COPY', icon: 'doc_on_clipboard', tooltip: $pbt('Copy this component to the clipboard.'), showOnlyWhenActive: true, onClick: onCopy });
    }
    if (editorOptions.allowCopyPaste && editorOptions.allowChildren && ((_c = editorOptions.childTypeNames) === null || _c === void 0 ? void 0 : _c.includes($currentCopyPasteItem === null || $currentCopyPasteItem === void 0 ? void 0 : $currentCopyPasteItem.componentType))) {
        buttons.push({ id: 'PASTE_CHILD', icon: 'yc_icon_paste', tooltip: $pbt('Paste the last copied component as the last child of this one.'), showOnlyWhenActive: true, onClick: onPasteChild });
    }
    if (editorOptions.allowCopyPaste && editorOptions.componentTypeName === ($currentCopyPasteItem === null || $currentCopyPasteItem === void 0 ? void 0 : $currentCopyPasteItem.componentType)) {
        buttons.push({ id: 'PASTE_SIBLING', icon: 'yc_icon_paste', tooltip: $pbt('Paste the last copied component after this one.'), showOnlyWhenActive: true, onClick: onPasteSibling });
    }
    if (editorOptions.allowDeletion) {
        buttons.push({ id: 'DELETE', icon: 'trash_fill', tooltip: $pbt('Delete this component.'), showOnlyWhenActive: true, onClick: onDelete });
    }
}
function handleMouseEnter() {
    thisMouseHover = true;
}
function handleMouseLeave() {
    thisMouseHover = false;
}
function getOrCreateChildrenArray(editorOptions) {
    const c = editorOptions.component;
    const k = editorOptions.childrenKey;
    if (!_.isArray(c[k])) {
        c[k] = [];
        doUpdate();
    }
    return c[k];
}
function unselectMyself() {
    if (thisSelected) {
        emm.setSelectedComponentEditorOptions(null);
        emm.setSelectedComponentId(null);
    }
}
// Update selected component editor options any time anything within it changes and we're selected
$: if (thisSelected) {
    emm.setSelectedComponentEditorOptions({
        title: ((editorOptions.component.displayName) ? `${editorOptions.component.displayName} (${$pbt(editorOptions.componentTypeName)})` : $pbt(editorOptions.componentTypeName)) + ` ${$pbt('Properties')}`,
        barColor: editorOptions.selectedBackgroundColor,
        textColor: editorOptions.selectedTextColor,
        schema: editorSchema,
        data: editorOptions.component,
        onUpdate: mergeChangesAndUpdate,
        onFileUpload: emm.beginFileUpload.bind(emm),
        closePopup: onEditPopupClosed,
        componentId: editorOptions.componentId,
    });
}
async function openEditPopup() {
    f7.preloader.show('black');
    editorSchema = await generateSchema();
    //emm.disableSave();
    //editPopupOpened = true;
    f7.preloader.hide();
}
function onEditPopupClosed() {
    //editPopupOpened = false;
    //emm.enableSave();
    unselectMyself();
}
async function onEdit() {
    await openEditPopup();
}
async function onThisSelected(thisSelected) {
    if (!thisSelected) {
        return;
    }
    await onEdit();
}
$: onThisSelected(thisSelected);
async function onNameClick() {
    emm.setSelectedComponentId(editorOptions.componentId);
}
function onSelectParent() {
    if ($parentSubtreeContextStore) {
        emm.setSelectedComponentId($parentSubtreeContextStore.componentId);
    }
}
function onMoveUp() {
    $parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.moveUpChild(editorOptions.componentId);
}
function onMoveDown() {
    $parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.moveDownChild(editorOptions.componentId);
}
function onAddRepeat() {
    //console.log("ON ADD REPEAT", editorOptions.component);
    if (_.isFunction(editorOptions.addRepeat)) {
        editorOptions.addRepeat();
    }
    else {
        editorOptions.component.repeat = Math.max((editorOptions.component.repeat || 1) + 1, 1);
    }
    doUpdate();
}
function onRemoveRepeat() {
    //console.log("ON REMOVE REPEAT", editorOptions.component);
    if (_.isFunction(editorOptions.removeRepeat)) {
        editorOptions.removeRepeat();
    }
    else {
        editorOptions.component.repeat = (editorOptions.component.repeat || 1) - 1;
        if (editorOptions.component.repeat <= 1) {
            delete editorOptions.component.repeat;
        }
    }
    doUpdate();
}
function onAddSiblingBefore() {
    $parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.addChildBefore(editorOptions.componentId);
}
function onAddSiblingAfter() {
    $parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.addChildAfter(editorOptions.componentId);
}
function onClone() {
    $parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.cloneChild(editorOptions.componentId);
}
function onAddChild() {
    addChild();
}
function onCut() {
    // console.log('oncut');
    onCopy();
    onDelete();
}
function onCopy() {
    // console.log('oncopy');
    currentCopyPasteItem.set({
        componentType: editorOptions.componentTypeName,
        copyTime: new Date().toISOString(),
        data: $parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.getChildSubtree(editorOptions.componentId),
    });
}
function onPasteChild() {
    // console.log('ON PASTE CHILD', get(currentCopyPasteItem));
    addChild(cloneItemWithNewIds(get(currentCopyPasteItem).data));
}
function onPasteSibling() {
    const newChild = cloneItemWithNewIds(get(currentCopyPasteItem).data);
    // console.log('ON PASTE SIBLING', get(currentCopyPasteItem), newChild);
    $parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.addChildAfter(editorOptions.componentId, newChild);
}
function onDelete() {
    // console.log('ondelete');
    unselectMyself();
    $parentSubtreeContextStore === null || $parentSubtreeContextStore === void 0 ? void 0 : $parentSubtreeContextStore.removeChild(editorOptions.componentId);
}
/* */
function doUpdate() {
    editorOptions.updater(editorOptions.component);
    emm.notifyPageDataUpdate();
}
function cloneItemWithNewIds(item) {
    return _.cloneDeepWith(item, (v, k) => {
        if (k === 'id' && _.isString(v)) {
            return uuid4();
        }
        if (_.isString(k) && k.startsWith('__')) {
            return null;
        }
    });
}
function getChildSubtree(id) {
    return getOrCreateChildrenArray(editorOptions).find((i) => i.id === id);
}
function createChild() {
    return (_.isFunction(editorOptions.createChild)) ?
        editorOptions.createChild() :
        { id: uuid4() };
}
function addChild(newChild = null) {
    if (!newChild) {
        newChild = createChild();
    }
    // console.log('ADD CHILD', newChild);
    getOrCreateChildrenArray(editorOptions).push(newChild);
    doUpdate();
}
function moveUpChild(id) {
    const arr = getOrCreateChildrenArray(editorOptions);
    let idx = arr.findIndex((i) => i.id === id);
    if (idx > 0) {
        const temp = arr[idx - 1];
        arr[idx - 1] = arr[idx];
        arr[idx] = temp;
        doUpdate();
    }
}
function moveDownChild(id) {
    const arr = getOrCreateChildrenArray(editorOptions);
    let idx = arr.findIndex((i) => i.id === id);
    if (idx >= 0 && idx < arr.length - 1) {
        const temp = arr[idx + 1];
        arr[idx + 1] = arr[idx];
        arr[idx] = temp;
        doUpdate();
    }
}
function cloneChild(id) {
    const arr = getOrCreateChildrenArray(editorOptions);
    let idx = arr.findIndex((i) => i.id === id);
    if (idx >= 0) {
        arr.splice(idx + 1, 0, cloneItemWithNewIds(arr[idx]));
        doUpdate();
    }
}
function removeChild(id) {
    const arr = getOrCreateChildrenArray(editorOptions);
    let idx = arr.findIndex((i) => i.id === id);
    if (idx >= 0) {
        arr.splice(idx, 1);
        doUpdate();
    }
}
function addChildBefore(id, newChild) {
    const arr = getOrCreateChildrenArray(editorOptions);
    let idx = arr.findIndex((i) => i.id === id);
    if (idx >= 0) {
        if (!newChild) {
            newChild = createChild();
        }
        arr.splice(idx, 0, newChild);
        doUpdate();
    }
}
function addChildAfter(id, newChild) {
    const arr = getOrCreateChildrenArray(editorOptions);
    let idx = arr.findIndex((i) => i.id === id);
    if (idx >= 0) {
        if (!newChild) {
            newChild = createChild();
        }
        arr.splice(idx + 1, 0, newChild);
        doUpdate();
    }
}
function getChildren() {
    return getOrCreateChildrenArray(editorOptions).map((i) => {
        return { id: i.id };
    });
}
function getConfigValue(key) {
    var _a;
    return (_a = editorOptions === null || editorOptions === void 0 ? void 0 : editorOptions.component) === null || _a === void 0 ? void 0 : _a[key];
}
function setConfigValue(key, value) {
    if (editorOptions === null || editorOptions === void 0 ? void 0 : editorOptions.component) {
        editorOptions.component[key] = value;
        doUpdate();
    }
}
async function generateSchema() {
    let schema = (_.isFunction(editorOptions.configSpecGenerator)) ?
        // wrapping in Promise.resolve handles the case where configSpecGenerator doesn't return a promise
        await Promise.resolve(editorOptions.configSpecGenerator(editorOptions.component)) :
        editorOptions.configSpec;
    schema = Object.assign(Object.assign({}, schema), { description: `Layer ID: ${editorOptions.componentId}` });
    (function translateRecursive(s) {
        //console.log('translateRecursive', s);
        if (!_.isPlainObject(s)) {
            return;
        }
        Object.keys(s).forEach((k) => {
            var _a;
            if (k === 'title' || k === 'description') {
                s[k] = $pbt(s[k]);
            }
            else if (k === 'enum_titles' && ((_a = s[k]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                for (let i = 0; i < s[k].length; i++) {
                    s[k][i] = $pbt(s[k][i]);
                }
            }
            else {
                translateRecursive(s[k]);
            }
        });
    })(schema);
    return schema;
}
async function mergeChangesAndUpdate(data) {
    f7.preloader.show('black');
    //console.log("mergeChangesAndUpdate before merge", JSON.stringify(editorOptions.component, null, 2), data);
    // FIXME: This should do a sweep of specified properties in the json schema
    // and remove properties that are defined in the schema but are not in the data object
    function sweepAndDelete(schema, compData, formData) {
        if (!(schema === null || schema === void 0 ? void 0 : schema.properties) || !compData || !formData) {
            return;
        }
        Object.keys(schema.properties).forEach((k) => {
            if (!formData.hasOwnProperty(k)) {
                delete compData[k];
            }
            sweepAndDelete(schema.properties[k], compData[k], formData[k]);
        });
    }
    sweepAndDelete(editorSchema, editorOptions.component, data);
    //console.log("mergeChangesAndUpdate after sweepAndDelete", JSON.stringify(data, null, 2));
    _.mergeWith(editorOptions.component, data, (objValue, srcValue) => {
        // Tweak the merge algorithm to not merge arrays key-wise. Just overwrite the whole array with the source.
        if (_.isArray(objValue) && !_.isNil(srcValue)) {
            return srcValue;
        }
    });
    //console.log("mergeChangesAndUpdate after merge", JSON.stringify(editorOptions.component, null, 2));
    doUpdate();
    // For performance reasons, this is only regenerated here.
    editorSchema = await generateSchema();
    f7.preloader.hide();
}
$: emm.registerComponent({
    id: editorOptions.componentId,
    sequenceId: editorOptions.sequenceId,
    configSpec: { options: [] },
    options: editorOptions,
    onUpdate: mergeChangesAndUpdate,
    addChild,
    removeChild,
    getChildren,
    getConfigValue,
    setConfigValue
});
function handleMessage(event) {
    //console.log('GOT COMPONENT MESSAGE', event);
    const action = event.data;
    if (action.forwardToChildren) {
        const childAction = Object.assign(Object.assign({}, action), { forwardToChildren: false });
        getChildren().forEach(({ id }) => { sendMessageToComponent(id, childAction); });
    }
    else if (messageHandler) {
        messageHandler(action);
    }
    else {
        //console.log('CardsComponentWrapper.handleMessage: Warning - dropping message because no suitable handler was found.');
    }
}
let scrollParent = null;
let stickyScrollHandler = null;
let stickyActive = false;
let stickyActivationScrollHeight = 0;
let stickyTop = 0;
function updateStickyActive(newStickyActive) {
    if (stickyActive === newStickyActive) {
        return;
    }
    // console.log('SET STICKY ACTIVE', newStickyActive);
    stickyActive = newStickyActive;
    if (stickyActive) {
        const stickyHeight = wrapperEl.getBoundingClientRect().height;
        stickyPlaceholderEl.style.height = `${stickyHeight}px`;
        stickyTop = pageContext.stickyHeights.reduce((pv, cv) => pv + cv, 0);
        pageContext.stickyHeights.push(stickyHeight);
    }
    else {
        stickyPlaceholderEl.style.height = '0';
        stickyTop = 0;
        pageContext.stickyHeights.pop();
    }
}
$: if (wrapperEl && sticky && !stickyScrollHandler) {
    scrollParent = getVerticalScrollParent(wrapperEl);
    //console.log('STICKY SCROLL PARENT', scrollParent);
    stickyScrollHandler = () => {
        stickyTop = (stickyActive) ? stickyTop : pageContext.stickyHeights.reduce((pv, cv) => pv + cv, 0);
        stickyActivationScrollHeight = getScrollTargetPosition((stickyActive) ? stickyPlaceholderEl : wrapperEl, scrollParent, 0) - stickyTop;
        //console.log('STICKY ACTIVATION SCROLL HEIGHT', stickyActivationScrollHeight, scrollParent.scrollTop, document.body.contains(wrapperEl), scrollParent);
        //console.log({ scrollPosition: scrollParent.scrollTop, stickyActivationScrollHeight });
        // we have to check that the element is actually in the DOM, because it might have gotten removed during navigation
        updateStickyActive(document.body.contains(wrapperEl) && scrollParent.scrollTop >= stickyActivationScrollHeight);
    };
    //console.log({ scrollPosition: scrollParent.scrollTop, wrapperScrollHeight });
    scrollParent.addEventListener('scroll', stickyScrollHandler, { passive: true });
}
else if (scrollParent && !sticky && stickyScrollHandler) {
    scrollParent.removeEventListener('scroll', stickyScrollHandler);
    updateStickyActive(false);
    stickyScrollHandler = null;
    scrollParent = null;
}
let receivedSequentialDisplayToken = false;
let contentQuiescent = false;
let sdtok = null;
$: if (!pageContext.useSequentialDisplay) {
    contentQuiescent = true;
    imageLoadBarrierStore === null || imageLoadBarrierStore === void 0 ? void 0 : imageLoadBarrierStore.set(true);
}
else if (waitUntilContentLoaded && contentLoaded && receivedSequentialDisplayToken && !contentQuiescent) {
    //console.log('READY TO PASS THE TOKEN', editorOptions?.sequenceId, editorOptions?.componentId);
    tick().then(() => tick().then(() => setTimeout(() => {
        if (!contentQuiescent) {
            contentQuiescent = true;
        }
        if (sdtok) {
            //console.log('PASSING THE TOKEN!', editorOptions?.sequenceId, editorOptions?.componentId);
            sdtok.next();
            sdtok = null;
        }
    }, 100)));
}
function handleSequentialDisplay(e) {
    //console.log('GOT SEQUENTIAL DISPLAY EVENT!', e);
    if (!pageContext.useSequentialDisplay || contentQuiescent) {
        e.detail.next();
    }
    else {
        receivedSequentialDisplayToken = true;
        sdtok = e.detail;
        imageLoadBarrierStore === null || imageLoadBarrierStore === void 0 ? void 0 : imageLoadBarrierStore.set(true);
    }
}
afterUpdate(afterUpdateDebounce(() => {
    //if (sticky) console.log('STICKY AFTER UPDATE', sticky, scrollParent);
    if (sticky && scrollParent) {
        const currentScrollParent = getVerticalScrollParent(wrapperEl);
        if (!currentScrollParent.isEqualNode(scrollParent)) {
            // console.log('CHANGE STICKY SCROLL PARENT');
            scrollParent.removeEventListener('scroll', stickyScrollHandler);
            scrollParent = currentScrollParent;
            scrollParent.addEventListener('scroll', stickyScrollHandler, { passive: true });
            stickyScrollHandler();
        }
    }
}));
let lockedHeightTimerHandle = null;
let fadeDuringSourceChange = false;
onMount(() => {
    var _a, _b;
    fadeDuringSourceChange = (editorOptions === null || editorOptions === void 0 ? void 0 : editorOptions.componentId) == '56940c65-b19e-4b26-9808-b111b2a29fc3';
    (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store.subscribe(() => {
        try {
            if (wrapperEl && waitUntilContentLoaded && contentQuiescent && pageContentLoaded && !disableWaitUntilContentLoaded) {
                const bbox = wrapperEl.getBoundingClientRect();
                lockedHeightPx = bbox.height;
                setTimeout(() => {
                    var _a;
                    const globalStatus = get((_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.dataSourceManager) === null || _a === void 0 ? void 0 : _a.getGlobalStatusStore());
                    if (lockedHeightPx && !globalStatus.pendingLoad && !globalStatus.pendingChanges) {
                        //console.log('NO PENDING LOADS/CHANGES (PARAM CHANGE CHECK), UNLOCK HEIGHT');
                        if (lockedHeightTimerHandle) {
                            clearTimeout(lockedHeightTimerHandle);
                            lockedHeightTimerHandle = null;
                        }
                        setTimeout(() => lockedHeightPx = 0, 200);
                    }
                }, 200);
                if (lockedHeightTimerHandle) {
                    clearTimeout(lockedHeightTimerHandle);
                }
                // last resort
                lockedHeightTimerHandle = setTimeout(() => {
                    lockedHeightPx = 0;
                    lockedHeightTimerHandle = null;
                }, 10000);
            }
        }
        catch (e) {
            //console.log("caught exception setting locked height", e);
        }
    });
    if (waitUntilContentLoaded && !disableWaitUntilContentLoaded) {
        (_b = tabContext === null || tabContext === void 0 ? void 0 : tabContext.dataSourceManager) === null || _b === void 0 ? void 0 : _b.getGlobalStatusStore().subscribe((globalStatus) => {
            try {
                //console.log('GLOBAL STATUS CHANGE', globalStatus);
                if (lockedHeightPx && !globalStatus.pendingLoad && !globalStatus.pendingChanges) {
                    //console.log('NO PENDING LOADS/CHANGES, UNLOCK HEIGHT');
                    if (lockedHeightTimerHandle) {
                        clearTimeout(lockedHeightTimerHandle);
                        lockedHeightTimerHandle = null;
                    }
                    setTimeout(() => lockedHeightPx = 0, 200);
                }
                else if (!lockedHeightPx && (globalStatus.pendingLoad || globalStatus.pendingChanges)) {
                    if (wrapperEl && /*waitUntilContentLoaded &&*/ contentQuiescent && pageContentLoaded) {
                        // console.log('PENDING LOADS/CHANGES, LOCK HEIGHT');
                        lockedHeightPx = wrapperEl.getBoundingClientRect().height;
                    }
                }
            }
            catch (e) {
                //console.log("caught exception setting locked height", e);
            }
        });
    }
    else {
        imageLoadBarrierStore === null || imageLoadBarrierStore === void 0 ? void 0 : imageLoadBarrierStore.set(true);
    }
});
onDestroy(() => {
    emm.unregisterComponent(editorOptions.componentId);
    if (scrollParent && stickyScrollHandler) {
        scrollParent.removeEventListener('scroll', stickyScrollHandler);
        stickyScrollHandler = null;
    }
});
</script>
